"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const IconContainer_1 = __importStar(require("../IconContainer"));
const TimeIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsxs)(IconContainer_1.StyledSvg, { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: [(0, jsx_runtime_1.jsx)("path", { d: "M12 20.72c-4.817 0-8.735-3.918-8.735-8.735C3.265 7.168 7.183 3.25 12 3.25c4.817 0 8.735 3.918 8.735 8.735 0 4.817-3.918 8.735-8.735 8.735z", fill: "#fff" }), (0, jsx_runtime_1.jsx)("path", { d: "M12 4.53A7.472 7.472 0 0119.47 12 7.462 7.462 0 0112 19.47 7.472 7.472 0 014.53 12c.016-4.085 3.4-7.47 7.47-7.47zM12 2C6.482 2 2 6.482 2 12s4.482 10 10 10 10-4.482 10-10S17.518 2 12 2z" }), (0, jsx_runtime_1.jsx)("path", { clipRule: "evenodd", d: "M10.597 12.945V6.466h2.532V12.5l2.357 2.93-1.972 1.587-2.637-3.277a1.266 1.266 0 01-.28-.794z", fillRule: "evenodd" })] }));
exports.default = (0, IconContainer_1.default)(TimeIcon);
//# sourceMappingURL=index.js.map